import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconEmailPendingVerification = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 44.0664 32.0238",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group 2147234891",
		children: [/* @__PURE__ */ _jsx("g", {
			id: "Rectangle 64704",
			filter: "url(#filter0_iii_env)",
			children: /* @__PURE__ */ _jsx("rect", {
				x: .277344,
				y: 856595e-10,
				width: 43.789,
				height: 32.0238,
				rx: 1.33333,
				fill: "url(#paint0_linear_env)"
			})
		}), /* @__PURE__ */ _jsx("g", {
			id: "Polygon 7",
			filter: "url(#filter1_iii_env)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M26.265 14.6239C23.8056 16.6444 20.2608 16.6443 17.8014 14.6239L0.863148 0.709078C0.572986 0.470709 0.741541 -5.74362e-07 1.11706 -5.39432e-07L42.9493 3.35169e-06C43.3249 3.38662e-06 43.4934 0.470714 43.2033 0.709083L26.265 14.6239Z",
				fill: "url(#paint1_linear_env)"
			})
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_iii_env",
			x: -.291559,
			y: -2.84443,
			width: 47.2024,
			height: 35.4372,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: -.568902,
					dy: .568902
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.32744 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "shape",
					result: "effect1_innerShadow_env"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: 2.84451,
					dy: -2.84451
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2.56006 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_innerShadow_env",
					result: "effect2_innerShadow_env"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: -.568902 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .189634 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0.15254 0 0 0 0 0.406773 0 0 0 0.2 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect2_innerShadow_env",
					result: "effect3_innerShadow_env"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter1_iii_env",
			x: -1.9504,
			y: -18.6667,
			width: 63.9672,
			height: 37.4726,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: -2.66667,
					dy: 2.66667
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 9.33333 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0117647 0 0 0 0 0.0784314 0 0 0 0 0.180392 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "shape",
					result: "effect1_innerShadow_env2"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: 18.6667,
					dy: -18.6667
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 16 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0392157 0 0 0 0 0.0392157 0 0 0 0 0.0392157 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_innerShadow_env2",
					result: "effect2_innerShadow_env2"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: -2.66667 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.33333 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0392157 0 0 0 0 0.0392157 0 0 0 0 0.0392157 0 0 0 0.2 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect2_innerShadow_env2",
					result: "effect3_innerShadow_env2"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_env",
			x1: 12.383,
			y1: 9.19,
			x2: 53.9343,
			y2: 38.3112,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0064FA" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#00D3F3"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_env",
			x1: 31.884,
			y1: 12.9061,
			x2: 7.49928,
			y2: -17.5219,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0064FA" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#00D3F3"
			})]
		})
	] })]
});
export default SvgIconEmailPendingVerification;
